module.exports = __webpack_public_path__ + "static/media/step-1.a59bfcbc.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/BuyForMe/icons/step-1.svg
 ** module id = 875
 ** module chunks = 0
 **/